import React from 'react';

function Features(props) {
  return (
    <section id="features">
      <div className="container px-5">
        <div className="row gx-5 align-items-center">
          <div className="col-lg-8 order-lg-1 mb-5 mb-lg-0">
              <div className="container-fluid px-5">
                  <div className="row gx-5">
                      <div className="col-md-6 mb-5">
                        <div className="text-center">
                          <i className="bi-lock icon-feature text-gradient d-block mb-3"></i>
                          <h3 className="font-alt">Private Memes</h3>
                          <p className="text-muted mb-0">Save and share memes only you and people you chose can see</p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-5">
                        <div className="text-center">
                          <i className="bi-keyboard icon-feature text-gradient d-block mb-3"></i>
                          <h3 className="font-alt">Imessage Keyboard</h3>
                          <p className="text-muted mb-0">Search and send memes right from Imessage</p>
                        </div>
                      </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-5">
                      <div className="text-center">
                        <i className="bi bi-gear icon-feature text-gradient d-block mb-3"></i>
                        <h3 className="font-alt">Custom Search Algorithms</h3>
                        <p className="text-muted mb-0">Use settings to optimize your content search exactly how YOU want it!</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="text-center">
                        <i className="bi-people icon-feature text-gradient d-block mb-3"></i>
                        <h3 className="font-alt">Groups</h3>
                        <p className="text-muted mb-0">Create a public and private groups</p>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
          <div className="col-lg-4 order-lg-0">
            <div className="features-device-mockup">
              <svg className="circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="circleGradient" gradientTransform="rotate(45)">
                    <stop className="gradient-start-color" offset="0%"></stop>
                    <stop className="gradient-end-color" offset="100%"></stop>
                  </linearGradient>
                </defs>
                <circle cx="50" cy="50" r="50"></circle>
              </svg>
              <svg className="shape-1 d-none d-sm-block" viewBox="0 0 240.83 240.83" xmlns="http://www.w3.org/2000/svg">
                <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03" transform="translate(120.42 -49.88) rotate(45)"></rect>
                <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03" transform="translate(-49.88 120.42) rotate(-45)"></rect>
              </svg>
              <svg className="shape-2 d-none d-sm-block" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg>
              <div className="device-wrapper">
                <div className="device" data-device="iPhoneX" data-orientation="portrait" data-color="black">
                  <div className="screen bg-black">
                    {/* <video muted="muted" autoPlay={true} loop="" style={{maxWidth: '100%', height: '100%'}}>
                      <source src="src/assets/demo-screen.mp4" type="video/mp4" />
                    </video> */}
                    <img className="img-fluid" src="/assets/groups-screengrab.png" alt="..." style={{maxWidth: '120%', height: '100%'}} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;